module.exports = __webpack_public_path__ + "img/22181261_s.bea7607c.jpg";